import React from 'react'
import Welcom from '../Components/welcom Page/Welcom'
import Speciality from '../Components/Speciality/Speciality'
import TopDoctors from '../Components/Top Doctors/TopDoctors'
import Banner from '../Components/Banner/Banner'
import Footer from '../Components/Footer/Footer'



const Home = () => {
    return (
        <>
            <Welcom />
            <Speciality />
            <TopDoctors />
            <Banner />
        </>

    )
}

export default Home
